import Page from '../pages/model'
import api from '@/helpers/api'
import { map } from 'lodash'

export default {
    state: {

    },

    mutations: {

    },

    getters: {
        cpoList (state, getters) {
            return getters.query().get()
        },
    },

    actions: {
        fetchItems (store, params) {
            Page.dispatch('addLoader', 'organizations.fetchItems')

            return api.get('/api/v1/dictionaries/Cpo').then((res)=>{
                let organizations = map(res.data, item => {
                    if (!item.name && item.text) item.name = item.text
                    return item
                })
                store.dispatch('insertOrUpdate', { data: organizations})
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'organizations.fetchItems')
            })
        },
    }
}
